
// Import JS Modules
import { builderDispatch, PrismUI } from '../../../_utils/ui';
import LoaderAdditionalOptions from '../../../_photo-loader/additional-options';
import { usePrismItemStore } from 'stores/usePrismItemStore';

// --------------------------------------------------------------------

function uploadUrl() {
  const prismItem = usePrismItemStore.getState().prismItem;
  
  return `/edt/img/add/${prismItem.sec}/${prismItem.num}?json=1`;
}

function fireAddPhotos() {
  builderDispatch.delayedDispatch({
    type: PrismUI.HIDE_OVERLAY
  })

  builderDispatch.delayedDispatch({
    type: PrismUI.ADD_PHOTOS,
    upload_url: uploadUrl(),
    callToActionButtonText: 'Add Photos',
    callToActionButtonEvent: 'event_add_photos',
    add_title_text: 'photos will be added to your product',
  });
}

// --------------------------------------------------------------------

export {
  fireAddPhotos,
  uploadUrl,
};
